const config = {
    baseURL: 'http://134.209.229.62:8095/api',
    protectedVariables: {
        roleId: [1],
        departmentId: [1]
    },
    bidStatus: [{key:'WAITING', text: 'BEKLİYOR'}, {key:'POSITIVE', text: 'OLUMLU'}, {key:'NEGATIVE', text: 'OLUMSUZ'}],
    shippingStatus: [{key: 'COMPLETED', text: 'TAMAMLANDI'}, {key: 'WAITING', text: 'BEKLIYOR'}],
    cargoOptions: ['ARAS KARGO', 'MNG KARGO', 'SÜRAT KARGO', 'YURT İÇİ KARGO'],
    currencyOptions: ['EUR', 'USD', 'TRY'],
    currentTenant() {
        return window.localStorage.getItem('tenant')
    },
    shipmentTypes: {
        "VEHICLE": "ARAÇ",
        "CARGO": "KARGO",
        "MANUEL": "ELDEN"
    },
    tenants: {
        arma: "arma",
        gohkan: "gokhan"
    },
    commonTax: 0.20,
    totalWithCommonTax: 1.20,
    userDateFormat: 'DD/MM/YYYY',
    armaBankAccounts: [
        {
            name: 'AKBANK (156) BANKALAR CADDESİ ŞUBESİ 53765',
            key: 'TR31 0004 6001 5688 8000 0537 65'
        },
        {
            name: 'AKBANK BANKALAR CADDESİ USD HESABI',
            key: 'TR17 0004 6001 5600 1000 0541 05'
        },
        {
            name: 'GARANTİ BANKASI GALATA ŞUBESİ',
            key: 'TR81 0006 2000 0670 0006 2964 59'
        },
        {
            name: 'TEB BANKASI TOPÇULAR ŞUBESİ',
            key: 'TR33 0003 2000 0000 0061 8063 69'
        },
        {
            name: 'YAPIKREDİ BANKALAR CADDESİ',
            key: 'TR32 0006 7010 0000 0092 7082 42'
        }
    ],
    address: {
        arma: {
            companyName: "ARMA LED AYDINLATMA ELEMANLARI İMALAT SAN. VE TİC. A.Ş.",
            st: "Şerifali Mah Beyit Sk BSB Plaza No:52 Kat:2 34775 Ümraniye-İstanbul",
            phone: "0(216) 365 46 46",
            pbx: "0(216) 365 46 49",
            taxOffice: "Sarıgazi V.D",
            taxNo: "079 034 8983"
        },
        gokhan: {
            companyName: "GÖKHAN ELEKTRİK MALZEMELERİ SAN. VE TİC. LTD. ŞTİ.",
            st: "Şerifali Mah Beyit Sk BSB Plaza No:52 Kat:3 34775 Ümraniye-İstanbul",
            phone: "0(216) 420 81 81",
            pbx: "0(216) 420 81 84",
            taxOffice: "Sarıgazi V.D",
            taxNo: "403 000 4884"
        }
    },
    stockUnits: [
        {value: 'Adet'},
        {value: 'Metre'},
        {value: 'Metre-Kare'},
        {value: 'Litre'},
        {value: 'Paket'},
        {value: 'Plaka'},
        {value: 'Çift'},
        {value: 'Desi'},
        {value: 'Kg'},
    ],
    limitDates: {
        max: new Date('01.01.2100'),
        min: new Date(1)
    }
}

export default config